module.exports = __webpack_public_path__ + "static/img/1.1f7a91b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hjzz/1.png
// module id = M3JH
// module chunks = 1